const defaultRender = (value) => (value ? value : "--");

const taskList = [
  { text: "Verify Doc", value: "task1" },
  { text: "Prepare Tax", value: "task2" },
  { text: "Review Tax", value: "task3" },
  { text: "Follow Up", value: "task4" },
  { text: "E-file", value: "task5" },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Task",
    dataIndex: "task_name",
    render: defaultRender,
    filters: taskList,
    onFilter: (value, record) => {
      return record?.task_order === value;
    },
  },
  {
    title: "Assigned To",
    dataIndex: "assignTo",
    render: defaultRender,
    onFilter: (value, record) => {
      return record?.employee?.name === value;
    },
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
];

export default columns;
